import type { GetServerSidePropsContext } from 'next';

export const CookieName = 'feature-flags';

export enum FeatureFlag {
	/** Speech-to-text in the Glazier Assistant composer, billed to our OpenAI key. Requires Business.enableGlazierChat. */
	CLARITY_VOICE = 'clarity_voice',
	/** Agentic auto-linking of email threads to jobs and customers. Requires Business.enable2WayEmail. */
	MAILBOX_AUTO_LINK = 'mailbox_auto_link',
}

const flagValues = Object.values(FeatureFlag) as string[];

export interface WithFeatureFlags {
	featureFlags: FeatureFlag[];
}

export function getFeatureFlagsFromString(flags: string): FeatureFlag[] {
	return flags.split(',').filter((flag) => flagValues.includes(flag)) as FeatureFlag[];
}

export function getEnabledFeatureFlags(req: GetServerSidePropsContext['req']): WithFeatureFlags {
	const cookieFeatureFlags: string = req.cookies[CookieName] ?? '';

	return {
		featureFlags: getFeatureFlagsFromString(cookieFeatureFlags),
	};
}

export function isFeatureEnabled(props: WithFeatureFlags, flag: FeatureFlag): boolean {
	return props.featureFlags?.includes(flag);
}
